export default "/directory/static/vowel_assistance.b662ffb7.svg";